import React, { useState } from "react";
import "./ContactForm.css";

const API_BASE = process.env.REACT_APP_API_BASE || "https://api.aspectstudios.org";

function ContactForm({
	productForm = false,
	emailSubject = "Contactformulier",
	formTitleText = "NEEM CONTACT MET ONS OP",
	eyebrow = "CONTACT",
}) {
	const [formData, setFormData] = useState({
		voornaam: "",
		achternaam: "",
		email: "",
		telefoon: "",
		beschrijving: "",
		locatie: "",
		datum: "",
	});

	// idle | sending | success | error — drives the inline feedback + button.
	const [status, setStatus] = useState("idle");

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault(); // Prevent default form submission
		if (status === "sending") return; // no double submits
		setStatus("sending");

		try {
			const response = await fetch(`${API_BASE}/api/submit-form`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					...formData,
					_subject: emailSubject,
					site: "vanvlimmerenfeestverhuur.nl",
				}),
			});

			if (!response.ok) {
				throw new Error("Form submission failed");
			}

			setStatus("success");
			setFormData({
				voornaam: "",
				achternaam: "",
				email: "",
				telefoon: "",
				beschrijving: "",
				locatie: "",
				datum: "",
			});
		} catch (error) {
			console.error("Error:", error);
			setStatus("error");
		}
	};
	return (
		<section className="contact-form-section" id="contact">
			<div className="contact-form-container">
				<div className="contact-title">
					<span className="contact-eyebrow">{eyebrow}</span>
					<h2>{formTitleText}</h2>
					<div className="contact-title-rule" aria-hidden="true"></div>
				</div>

			<form className="contact-form" onSubmit={handleSubmit}>
				<input type="hidden" name="_subject" value={emailSubject} />
				<div className="form-row">
					<div className="form-group">
						<label htmlFor="voornaam">Voornaam</label>
						<input
							type="text"
							id="voornaam"
							name="voornaam"
							value={formData.voornaam}
							onChange={handleChange}
							required
						/>
					</div>
					<div className="form-group">
						<label htmlFor="achternaam">Achternaam</label>
						<input
							type="text"
							id="achternaam"
							name="achternaam"
							value={formData.achternaam}
							onChange={handleChange}
							required
						/>
					</div>
				</div>
				<div className="form-row">
					<div className="form-group">
						<label htmlFor="email">Email</label>
						<input
							type="email"
							id="email"
							name="email"
							value={formData.email}
							onChange={handleChange}
							required
						/>
					</div>
					<div className="form-group">
						<label htmlFor="telefoon">Telefoonnummer</label>
						<input
							type="tel"
							id="telefoon"
							name="telefoon"
							value={formData.telefoon}
							onChange={handleChange}
							required
						/>
					</div>
				</div>
				{productForm && (
					<div className="form-row">
						<div className="form-group">
							<label htmlFor="locatie">Locatie</label>
							<input
								type="text"
								id="locatie"
								name="locatie"
								value={formData.locatie}
								onChange={handleChange}
								required
							/>
						</div>
						<div className="form-group">
							<label htmlFor="datum">Datum</label>
							<input
								type="date"
								id="datum"
								name="datum"
								value={formData.datum}
								onChange={handleChange}
								required
							/>
						</div>
					</div>
				)}
				<div className="form-group full-width">
					<label htmlFor="beschrijving">Bericht</label>
					<textarea
						id="beschrijving"
						name="beschrijving"
						rows="6"
						value={formData.beschrijving}
						onChange={handleChange}
						placeholder="Stel hier uw vraag..."
						required></textarea>
				</div>

				{status === "success" && (
					<p className="form-status form-status--success" role="status">
						Bedankt voor uw bericht! We nemen zo spoedig mogelijk contact
						met u op.
					</p>
				)}
				{status === "error" && (
					<p className="form-status form-status--error" role="alert">
						Er is iets misgegaan bij het versturen. Probeer het later
						opnieuw, of bel ons op 06-18218292.
					</p>
				)}

				<button
					type="submit"
					className="btn btn--primary btn--lg contact-submit"
					disabled={status === "sending"}>
					{status === "sending" ? "Versturen…" : "Versturen"}
				</button>
			</form>
			</div>
		</section>
	);
}

export default ContactForm;
